(function () {
    "use strict";

    angular.module("app").controller("OrganisationViewOnlyController", OrganisationViewOnlyController);
    OrganisationViewOnlyController.$inject = ["$rootScope", "$scope", "$timeout", "enumService", "controllerDecorator", "tabNavigationService", "OrganisationRemarkValidator"];
    function OrganisationViewOnlyController($rootScope, $scope, $timeout, enumService, controllerDecorator, tabNavigationService, OrganisationRemarkValidator) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["files", "comments", "navigation"]);

        $scope.request = null;
        $scope.statusesList = [{ Key: '10' }, { Key: '70' }, { Key: '90' }, { Key: '100' }, { Key: '120' }, { Key: '130' }, { Key: '150' }, { Key: '170' }, { Key: '200' }];

        $scope.isCurrent = tabNavigationService.IsActive;

        function linkData(data) {
            $scope.request = data;

            vm.Comments.Initialize({ RequestId: data.PublicId, OrganisationId: data.DossierPublicId, ICD: data.ScreeningBy });

            if ($scope.request.InitialAction === enumService.FvmInitialActions.Change) {
                $scope.statusesList = [
                    { Key: '11' },
                    { Key: '71' },
                    { Key: '81' },
                    { Key: '120' },
                    { Key: '130' },
                    { Key: '168' },
                    { Key: '170' },
                    { Key: '200' }
                ];
            }
        }

        function initialize() {
            $scope.requestId = vm.ParseUrl().parameters.requestid;

            if (!$scope.requestId)
                return;

            vm.SetLoadingState(true);

            vm.Api.GetFVMPhase2(
                { RequestId: $scope.requestId },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    linkData(result.data);

                    vm.Api.GetFvmPhase1SignaturesByUser({ FvmId: $scope.request.PublicId }, (r) => $scope.Signatures = r.data);                    
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
        
        function remarkFilterFactory(sections) {
            return function (remark) {
                return sections.includes(remark.Section);
            };
        }

        $scope.filterRemarkFunctionIdentity = remarkFilterFactory(['110']);
        $scope.filterRemarkFunctionJustification = remarkFilterFactory(['120']);

        $scope.filterPersonInvalidated = remarkFilterFactory(['140']);

        $scope.DoesItemContainSectionRemark = (item, section) => item.Remarks.some(remark => remark.Section === section);

        initialize();

        $scope.OpenIvm = function (person) {
            vm.Navigator.OpenIvmViewOnly(person.IVMLink);
        };

        function getEmbeddedTranslation(object, key) {
            const translation = object[key + vm.Settings.locale.toUpperCase()];

            return translation ? translation : object[key + "EN"];
        }

        $scope.GetPersonActionDescription = getPersonActionDescription;
        function getPersonActionDescription(person) {
            if (!person)
                return;

            const actionDescriptions = [];

            if (person.StatusCode === enumService.PersonStatusCodes.UserBlock) {
                actionDescriptions.push(vm.getTranslation("Person_Remark_Remove"));

                return actionDescriptions.join(' / ');
            }

            if (person.Action) {
                const actionDescription = getEmbeddedTranslation(person.Action, "Description");

                if (person.Action.Code === enumService.PersonActionCodes.StartIVM) {
                    const statusCode = $rootScope.codeStatusRequestsIVMFromFVM.find(o => o.Key == person.IVMStatus);
                    if (statusCode) {
                        actionDescriptions.push(`${actionDescription} [${statusCode.Value}]`);

                        if (getNoAcknowledgmentChosenFor(person).length > 0) {
                            if (!person.IsInvitedToSignNoAcknowledgementDocument) {
                                actionDescriptions.push(vm.getTranslation("NoAcknowledgment_Title"));
                            }
                            else {
                                if (!person.HasSendNoAcknowledgeDocument) {
                                    actionDescriptions.push(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                                }
                                else {
                                    actionDescriptions.push(vm.getTranslation("NoAcknowledgementWasSigned"));
                                }
                            }
                        }
                    }
                    else {
                        actionDescriptions.push(actionDescription);
                    }
                } else if (person.Action.Code === enumService.PersonActionCodes.NoAcknowledgement) {
                    if (person.IsInvitedToSignNoAcknowledgementDocument) {
                        if (!person.HasSendNoAcknowledgeDocument) {
                            actionDescriptions.push(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                        } else {
                            actionDescriptions.push(vm.getTranslation("NoAcknowledgementWasSigned"));
                        }
                    }
                    else {
                        actionDescriptions.push(actionDescription);
                    }
                }
                else {
                    // Action required
                    actionDescriptions.push(actionDescription);
                }
            }

            return actionDescriptions.join(' / ');
        }

        function getNoAcknowledgmentChosenFor(person) {
            if (!person || !person.NoAcknowledgementForClearanceCodes)
                return [];

            return JSON.parse(person.NoAcknowledgementForClearanceCodes);
        }

        /**
         * Called by ng-init to open invalidated justifications on load
         * @param {Object} justification The justification model
         * @param {Number} index The index of the justification in the request
         */
        $scope.InitializeJustificationState = function (justification, index) {
            // We NEED to use timeout to wait until after the justification is rendered
            // Without timeout we need to use ng-class to conditionally apply the in class
            // This causes issues when adding new items
            $timeout(() => setJustificationState(justification, index), 0);
        };

        //#endregion

        $scope.JustificationNeedsToBeValidated = justificationNeedsToBeValidated;
        function justificationNeedsToBeValidated(justification) {
            return !(justification.IsCopied && justification.Action === null);
        }

        function setJustificationState(justification, index) {
            if (!justificationNeedsToBeValidated(justification))
                return;

            const target = $(`#justification-${index}`);
            if (!OrganisationRemarkValidator.IsItemChecked(justification, 'justification'))
                target.collapse('show');
            else
                target.collapse('hide');
        }
    }
})();